import React, { useEffect, useRef, useState } from 'react'
import { useGetEventUserQuery, useUpdateEventUserMutation } from '../../api/eventUser.api'
import HTML from '../../components/HTML'
import { useMyContext } from '../../context/context'
import useSettingsV2 from '../../hooks/useSettingsV2'
import useTypos from '../../hooks/useTypos'
import Form from '../../shared/form'
import InputRadioCheckbox from '../../shared/form/input.radio.checkbox'
import { useSteps } from './Steps'

const Typos = () => {
  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()
  const { data: typos } = useTypos()

  const { data: eventUser } = useGetEventUserQuery({ ...myContext })

  const [selected, setSelected] = useState(eventUser?.UserEvent?.typoId || 'null')

  const { nextStep } = useSteps()

  const [updateUser] = useUpdateEventUserMutation()

  // L'auto-saut (typo déjà renseignée + TYPO_NEXT_STEP) ne doit partir qu'UNE fois par montage :
  // sinon un re-fetch d'`eventUser` pouvait relancer nextStep() et faire dépasser l'index.
  const advanced = useRef(false)

  useEffect(() => {
    if (advanced.current) return
    if ((eventUser?.UserEvent?.typo || eventUser?.UserEvent?.typoId) && settings?.FO_MEETING_TYPO_NEXT_STEP) {
      advanced.current = true
      console.log('NEXT STEP')
      nextStep()
    }
  }, [nextStep, settings, eventUser])

  return (
    <Form
      onSubmit={async () => {
        await updateUser({ ...myContext, eventUser: { typoId: selected === 'null' ? null : selected } }).unwrap()
        nextStep()
      }}
      disabled={settings?.FO_MEETING_TYPO_DEFAULT_HIDE ? selected === 'null' : false}
    >
      <HTML name="FO_MEETING_TYPO_HTML" />

      <InputRadioCheckbox
        label={settings?.FO_MEETING_TYPO_LABEL}
        options={typos}
        selectedValues={[selected]}
        type="radio"
        setSelectedValue={v => {
          setSelected(v)
        }}
        required
      />
    </Form>
  )
}

export default Typos
